import React from 'react'
import UpOutlined from '@ant-design/icons/lib/icons/UpOutlined'

export interface CollapseIconProps {
    isActive?: boolean
    className?: string
    color?: string
}

export const CollapseIcon: React.FC<CollapseIconProps> = ({
    isActive = false,
    className,
    color,
}) => {
    return (
        <UpOutlined
            className={className}
            rotate={isActive ? 0 : 180}
            style={color ? { color } : undefined}
        />
    )
}
